import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BatchConsumerResponseModel } from '../models/batch-consumer-response-model';
import { BatchConsumersService } from '../batch-consumers.service';

@Component({
    selector: 'edit-batch-consumer',
    standalone: true,
    imports: [CommonModule, FormsModule],
    providers: [BatchConsumersService],
    templateUrl: './edit-batch-consumer.component.html'
})
export class EditBatchConsumerComponent implements OnInit {
    @Input() batchConsumer: BatchConsumerResponseModel;
    @Input() isNew: boolean = false;

    public model: BatchConsumerResponseModel;
    public isSaving: boolean = false;
    public errorMessage: string = '';

    constructor(
        public activeModal: NgbActiveModal,
        private batchConsumersService: BatchConsumersService
    ) {}

    ngOnInit(): void {
        if (this.isNew) {
            this.model = {
                requestSource: '',
                isActive: true,
                serviceBusNamespace: '',
                serviceBusQueue: '',
                eventTypeSuffix: ''
            };
        } else {
            this.model = { ...this.batchConsumer };
        }
    }

    public save() {
        this.isSaving = true;
        this.errorMessage = '';

        if (this.isNew) {
            this.batchConsumersService.create(this.model).subscribe({
                next: (result) => {
                    this.activeModal.close({ action: 'save', data: result });
                },
                error: (error) => {
                    this.isSaving = false;
                    this.errorMessage = error?.error?.message || error?.message || 'Failed to create the batch consumer. Please try again.';
                }
            });
        } else {
            this.batchConsumersService.update(this.batchConsumer.requestSource, this.model).subscribe({
                next: (result) => {
                    this.activeModal.close({ action: 'save', data: result });
                },
                error: (error) => {
                    this.isSaving = false;
                    this.errorMessage = error?.error?.message || error?.message || 'Failed to update the batch consumer. Please try again.';
                }
            });
        }
    }

    public cancel() {
        this.activeModal.dismiss('cancel');
    }
}
